import { BitkitLink } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';

const WorkflowLink = ({ workflowName, workflowLinkUrl }: { workflowName: string; workflowLinkUrl?: string }) => {
  if (workflowLinkUrl) {
    return (
      <BitkitLink href={workflowLinkUrl} colorVariant="purple" textStyle="body/md/regular">
        {workflowName}
      </BitkitLink>
    );
  }

  return (
    <Text textStyle="body/md/regular" color="text/secondary">
      {workflowName}
    </Text>
  );
};

export default WorkflowLink;
